import router from "./router";
import store from "./store";
// import NProgress from "nprogress"; // Progress 进度条
// import "nprogress/nprogress.css"; // Progress 进度条样式
import { Message } from "element-ui";
import { getRefreshToken } from "@/utils/auth"; // 验权
import { $rrj } from "@/utils/rrjutils";
import { addLog } from "@/api/setting";
import { getUserModule } from "@/api/login";

const whiteList = ["/login", "/home", "/register", "/download"]; // 不重定向白名单

function getPageParams() {
  let url = window.location.href;
  let param = {};
  url.replace(/([^?&]+)=([^?&/]+)/g, function (s, v, k) {
    param[v] = decodeURIComponent(k); //解析字符为中文
    return k + "=" + v;
  });
  return param;
}

function getChildModules(id, Token) {
  getUserModule(id, Token).then((res) => {
    $rrj.storage.set("_module", res.data);

    store
      .dispatch("GetAsyncRoutes")
      .then(() => {
        router.addRoutes(store.getters.addRouters);
      })
      .catch(() => {
        store.dispatch("LogOut").then(() => {
          console.log("LogOut");
        });
      });
  });
}

router.beforeEach((to, from, next) => {
  // NProgress.start();
  console.log(to, "start----");

  // 授权跳转
  const { state, code } = getPageParams();
  if (state !== "teacherwx") {
    if (state === "10001") {
      console.log(state);
    } else if (state === "10002") {
      window.location.href = `https://assist.renrenjiang.cn/#/login?code=${code}&state=${state}`;
      return;
    } else if (state === "10003") {
      window.location.href = `https://assist.renrenjiang.cn/#/dashboard?code=${code}&state=${state}`;
      return;
    } else if (state === "10004") {
      window.location.href = `https://assist.renrenjiang.cn/#/dashboard?code=${code}&state=${state}`;
      return;
    } else if (code && state) {
      console.log(code, state);
      return;
    }
  }

  const user = $rrj.storage.get("_ukit");
  if (user) {
    // 访问统计
    const data = {
      way: "doudian_adm",
      appName: "抖音新版讲师中心",
      userId: (user && user.id) || 0,
      request_uri: to.fullPath,
      action: "pageVisit",
    };
    addLog(data);
  }

  const { access_token: accessToken } = to.query;

  if (accessToken) {
    store
      .dispatch("TokenLogin", { accessToken })
      .then(() => {
        console.log(to.path, "+++++++to.path+++++");
        if (to.path.indexOf("/p/") !== -1) {
          next({ path: "/p/dashboard" });
        } else {
          next({ path: to.path ? to.path : "/dashboard" });
        }
      })
      .catch(() => {
        next({ path: "/404", replace: true, query: { noGoBack: true } });
      });
  } else if ($rrj.storage.get("_token")) {
    if (to.path === "/login") {
      if (to.query.p) {
        next({ path: "/p/dashboard" });
      } else {
        next({ path: "/dashboard" });
      }
      // NProgress.done(); // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      // console.log(store.getters.permission_routers, "router");
      // 只有默认的路由
      if (store.getters.addRouters.length === 0) {
        // 获取动态路由
        store
          .dispatch("GetAsyncRoutes")
          .then((bool) => {
            // console.log(bool);
            // console.log(store.getters.addRouters, "store.getters.addRouters");
            if (bool) {
              router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表
              next({ ...to, replace: true });
            } else {
              next({ path: "/404", replace: true, query: { noGoBack: true } });
            }
          })
          .catch(() => {
            store.dispatch("LogOut").then(() => {
              next("/login");
            });
          });
      } else {
        const child_id = $rrj.storage.get("_child_id");
        if (child_id) {
          getChildModules(child_id, $rrj.storage.get("_token").id);
        }
        if (to.path !== "/") {
          next();
        } else {
          next("/home");
        }
      }
    }
  } else if (getRefreshToken()) {
    store
      .dispatch("RefreshToken")
      .then(() => {
        if (to.path === "/login") {
          next({ path: "/dashboard" });
        } else {
          next({ ...to, replace: true });
        }
      })
      .catch((err) => {
        store.dispatch("LogOut").then(() => {
          Message.error(err || "Verification failed, please login again");
          next({ path: "/" });
        });
      });
  } else {
    if (to.path === "/") {
      next("/home");
    } else if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      next("/login");
      // NProgress.done();
    }
  }
});

// router.afterEach(() => {
//   // NProgress.done(); // 结束Progress
// });
